<template>
  <v-container grid-list-md fluid class="pa-0">
    <v-card class="card-r no-shadow grey lighten-4 scroll-y" style="height:50vh; ">
      <!-- <v-toolbar class="primary mb-2 darken-2 card-r shadow-1 pl-3 text-white">
        <v-btn icon to="/packages">
          <v-icon color="white">keyboard_arrow_left</v-icon>
        </v-btn>
        <!--<router-link to="/"><v-icon class="text-white left pr-3">keyboard_arrow_left</v-icon></router-link>-->
        <!-- <div class="text-xs-left f-20">Add Packages</div>
      </v-toolbar> -->
                    <v-layout wrap >
                      <v-flex xs12 lg4><v-text-field solo :rules="requiredRule" v-model="PackageTitle" label="Package Title"></v-text-field>
                      </v-flex>
                      <v-flex xs12 lg2>
                        <v-select
                          :items="types"
                          label="Package Price Type"
                          solo
                          v-model="CostType"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 lg3 v-if="CostType=='cost'">
                        <v-text-field solo v-model="PackagePrice" type="number" :rules="requiredRule" label="Package Price"></v-text-field></v-flex>
                      <v-flex xs12 lg3 v-if="CostType=='cost'">
                        <v-text-field solo v-model="InternalPrice" type="number" :rules="requiredRule" label="Internal Price"></v-text-field></v-flex>
                      <v-flex xs12 lg12 v-if="CostType=='cost'">
                        <v-combobox solo :items="items" item-text="name" item-value="id" @change="callMultiple"  :rules="requiredRule"
                                    v-model="selectedClasses" label="Select all classes" multiple chips>
                          <template slot="selection" slot-scope="data">
                            <v-chip outline
                                    :selected="data.selectedClasses"
                                    :disabled="data.disabled"
                                    :key="JSON.stringify(data.item)"
                                    class="v-chip--select-multi"
                                    @input="data.parent.selectItem(data.item)">
                              <v-avatar
                                class="accent white--text"
                                v-text="data.item.slice(0, 1).toUpperCase()"></v-avatar>{{ data.item }}</v-chip>
                          </template>
                        </v-combobox>



                        <v-combobox solo :items="items1" item-text="" @change="callMultiple"  :rules="requiredRule"
                                    v-model="selectedFreeClasses" label="Select Free Classes" multiple chips>
                          <template slot="selection" slot-scope="data">
                            <v-chip outline
                                    :selected="data.selectedFreeClasses"
                                    :disabled="data.disabled"
                                    :key="JSON.stringify(data.item)"
                                    class="v-chip--select-multi"
                                    @input="data.parent.selectItem(data.item)">
                              <v-avatar
                                class="accent white--text"
                                v-text="data.item.slice(0, 1).toUpperCase()"></v-avatar>{{ data.item }}</v-chip>
                          </template>
                        </v-combobox>
                      </v-flex>


                      <v-flex xs12 lg12 v-if="CostType=='free'">
                        <v-combobox solo :items="items1" item-text="" @change="callMultiple"
                                    v-model="selectedFreeClasses" label="Select Free Classes" multiple chips>
                          <template slot="selection" slot-scope="data">
                            <v-chip outline
                                    :selected="data.selectedFreeClasses"
                                    :disabled="data.disabled"
                                    :key="JSON.stringify(data.item)"
                                    class="v-chip--select-multi"
                                    @input="data.parent.selectItem(data.item)">
                              <v-avatar
                                class="accent white--text"
                                v-text="data.item.slice(0, 1).toUpperCase()"></v-avatar>{{ data.item }}</v-chip>
                          </template>
                        </v-combobox>
                      </v-flex>
                      <!-- <v-flex xs12 lg12 v-if="CostType=='Custom'">
                        <v-combobox outline :items="items" item-text="" @change="callMultiple"  :rules="requiredRule"
                                    v-model="selectedClasses" label="Select Free Classes" multiple chips>
                          <template slot="selection" slot-scope="data">
                            <v-chip outline
                                    :selected="data.selectedClasses"
                                    :disabled="data.disabled"
                                    :key="JSON.stringify(data.item)"
                                    class="v-chip--select-multi"
                                    @input="data.parent.selectItem(data.item)">
                              <v-avatar
                                class="accent white--text"
                                v-text="data.item.slice(0, 1).toUpperCase()"></v-avatar>{{ data.item }}</v-chip>
                          </template>
                        </v-combobox>
                      </v-flex> -->

                      <!-- <v-flex xs12 lg12 v-if="CostType=='Free Upto three classes'">
                        <v-combobox outline :items="items" item-text="" @change="callMultiple"  :rules="requiredRule"
                                    v-model="selectedClasses" label="Select Classes by order" multiple chips>
                          <template slot="selection" slot-scope="data">
                            <v-chip outline
                                    :selected="data.selectedClasses"
                                    :disabled="data.disabled"
                                    :key="JSON.stringify(data.item)"
                                    class="v-chip--select-multi"
                                    @input="data.parent.selectItem(data.item)">
                              <v-avatar
                                class="accent white--text"
                                v-text="data.item.slice(0, 1).toUpperCase()"></v-avatar>{{ data.item }}</v-chip>
                          </template>
                        </v-combobox>
                      </v-flex> -->
                      <!-- <v-flex xs12 lg12 v-if="CostType=='After 3'">
                        <v-combobox outline :items="items" item-text="" @change="callMultiple"  :rules="requiredRule"
                                    v-model="selectedClasses" label="Select 3 Free Classes" multiple chips>
                          <template slot="selection" slot-scope="data">
                            <v-chip outline
                                    :selected="data.selectedClasses"
                                    :disabled="data.disabled"
                                    :key="JSON.stringify(data.item)"
                                    class="v-chip--select-multi"
                                    @input="data.parent.selectItem(data.item)">
                              <v-avatar
                                class="accent white--text"
                                v-text="data.item.slice(0, 1).toUpperCase()"></v-avatar>{{ data.item }}</v-chip>
                          </template>
                        </v-combobox>
                      </v-flex> -->

                      <!-- <v-flex xs12 lg12 v-if="CostType=='After 5'">
                        <v-combobox outline :items="items" item-text="" @change="callMultiple"  :rules="requiredRule"
                                    v-model="selectedClasses" label="Select pay Classes" multiple chips>
                          <template slot="selection" slot-scope="data">
                            <v-chip outline
                                    :selected="data.selectedClasses"
                                    :disabled="data.disabled"
                                    :key="JSON.stringify(data.item)"
                                    class="v-chip--select-multi"
                                    @input="data.parent.selectItem(data.item)">
                              <v-avatar
                                class="accent white--text"
                                v-text="data.item.slice(0, 1).toUpperCase()"></v-avatar>{{ data.item }}</v-chip>
                          </template>
                        </v-combobox>
                      </v-flex> -->
                      <!-- <v-flex xs12 lg12 v-if="CostType=='After 5'">
                        <v-combobox outline :items="items" item-text="" @change="callMultiple"  :rules="requiredRule"
                                    v-model="selectedClasses" label="Select 5 Free Classes" multiple chips>
                          <template slot="selection" slot-scope="data">
                            <v-chip outline
                                    :selected="data.selectedClasses"
                                    :disabled="data.disabled"
                                    :key="JSON.stringify(data.item)"
                                    class="v-chip--select-multi"
                                    @input="data.parent.selectItem(data.item)">
                              <v-avatar
                                class="accent white--text"
                                v-text="data.item.slice(0, 1).toUpperCase()"></v-avatar>{{ data.item }}</v-chip>
                          </template>
                        </v-combobox>
                      </v-flex> -->
                      <v-flex xs12 lg12 >
                        <v-textarea solo v-model="Description"  name="input-7-1" label="Description"></v-textarea>
                      </v-flex>
                      <v-flex xs12 lg12 class="text-xs-center">
                          <v-progress-circular
                              indeterminate
                              v-if=loading
                              color="primary"
                          ></v-progress-circular>
                          <v-alert
                            :value="true"
                            color="success"
                            icon="check_circle"
                            v-if="alert.type=='success'"
                            outline
                          >
                            {{alert.msg}}
                          </v-alert>
                          <v-alert
                            :value="true"
                            color="error"
                            icon="warning"
                            v-if="alert.type=='warning'"
                            outline
                          >
                            {{alert.msg}}
                          </v-alert>
                      </v-flex>
                      <v-flex lg12 xs12 class="text-xs-right">
                        <ConfirmSignup v-on:confirmyes="AddPackage" v-bind:value1="PackageTitle" v-bind:value2="PackagePrice"/>
                      </v-flex>
                    </v-layout>
            </v-card>
    </v-container>
</template>
<script>
  /* eslint-disable */
  //import ConfirmSignup from "../auth/ConfirmSignup";

  import ConfirmSignup from "@/components/pages/WidgetComponents/ConfirmPopup";
  import { mapState,dispatch } from 'vuex';
  import api from "@/utils/backend-api.js";

  export default {
    data: () => ({
      attachment: {
        photos: [],
        photosURL: [],
        videos: [],
        videosURL: []
      },
      PackageTitle:'',
      CostType:['free','cost'],
      PackagePrice:'',
      InternalPrice:'',
      Description:'',
      selectedClasses:'',
      selectedFreeClasses:'',
      module_id:[],
      free_modules:[],
      items: [],
      items1:[],
      newPackage: {
        typee: 'Pay',
        user: {
        },
      },
      types: ['free', 'cost'],
      // items1: [
      //   'Three Wheeler',
      //   'motor Bike',
      //   'Car',
      // ],
      loading:false,
      alert:{
        type:'',
        msg:''
      },
      requiredRule: [v => !!v || "This field is required"],
    }),
    watch: {},
    beforeCreate(){
      Store.dispatch('Modules/getAllClasses')
    },
    created() {
      Store.commit('setLoading', { loading: true })
      Store.dispatch('Modules/getAllClasses')
      Store.commit('setLoading', { loading: false })
      setTimeout(() => {
        //debugger
        for(var i=0;i<this.modules.length;i++){
          for(var y=0;y<this.modules.length;y++){
              // var id=this.modules[i].id
              var name=this.modules[i].name
              this.items.push(name)
              var FreeNames=this.modules[y].name
              this.items1.push(FreeNames)


          }
          }

              // var id=this.modules[i].id


      }, 1500);


    },
    methods: {
      AddPackage(){
          this.loading=true
          this.alert.type=""
          var PackageDetails={
                'name':this.PackageTitle,
                'price_type':this.CostType,
                'description':this.Description,
                'module_id':this.CostType=='free'?this.free_modules:this.module_id,
                'free_modules':this.free_modules,
                'cost':this.PackagePrice,
                'special_price':this.InternalPrice,
          }
          api.postData('admin/package/create', PackageDetails)
          .then(res => {
            console.log(res)
            if(res.status==201){
              this.loading=false
              this.alert.type="success"
              this.alert.msg="Package created successfully"
              if(res.status==201){
                this.$router.push('/packages');
              }
            }
          }).catch(res=>{
              this.loading=false
              this.alert.type="warning"
              this.alert.msg="Package creation failed"
          })
          // Store.dispatch('Packages/createPackage',PackageDetails).then(res=>{
          //   console.log(res)
          //     if(res.status==201){
          //         // this.$router.push('/packages');
          //     }
          // }).catch(error=>{
          //   console.log(error)
          // })
      },
      callMultiple(){
        // debugger
        this.ModuleNameToId()
        //this.packagePriceAutoCalculation()
      },
      ModuleNameToId() {
            this.module_id=[]
            this.free_modules=[]
            //debugger
            var ModuleList=Store.state.Modules.modules
            var Names=this.selectedClasses==''?[]:this.selectedClasses
            //var FreeModuleList=Store.state.Modules.freemodules
            //var allmodules=[]
            var FreeNames=this.selectedFreeClasses


          //var allmodules=Names.concat(FreeNames);
          for(let x=0;x<ModuleList.length;x++){
            for(var y=0;y<Names.length;y++){
                  if(Names[y]==ModuleList[x].name){
                    this.module_id.push(ModuleList[y].id)
                  }
            }
            for(var z=0;z<FreeNames.length;z++){
                  if(FreeNames[z]==ModuleList[x].name){

                    this.free_modules.push(ModuleList[x].id)

                  }
            }
          }

          // for(let x=0;x<ModuleList.length;x++){
          //   for(var y=0;y<FreeNames.length;y++){
          //         if(FreeNames[y]==ModuleList[x].name){
          //           debugger
          //           this.free_modules.push(ModuleList[x].id)

          //         }
          //   }
          // }

          console.log(this.module_id)
          console.log(this.free_modules)


            // }
      },

      // packagePriceAutoCalculation() {
      //       this.PackagePrice=''
      //       this.InternalPrice=''
      //       var ModuleList=Store.state.Modules.modules
      //       var Names=this.selectedClasses
      //       for(var i=0;i<Names.length;i++){
      //         for(var x=0;x<ModuleList.length;x++){
      //           if(Names[i]==ModuleList[x].name){
      //               this.PackagePrice=Number(this.PackagePrice)+Number(ModuleList[x].internal_price)
      //               this.InternalPrice=Number(this.InternalPrice)+Number(ModuleList[x].internal_price)
      //           }
      //         }
      //       }
      // },
      onPickImg(){
        this.$refs.ImgInput.click();
      },
      onImgPicked(){
        const files = event.target.files;
        let fileName = files[0].name;
        if (fileName.lastIndexOf(".") <= 0) {
          return alert("Please add a valid file! ");
        }
        const fileReader = new FileReader();
        fileReader.addEventListener("load", () => {
          this.attachment.photosURL.push(fileReader.result);

        });
        fileReader.readAsDataURL(files[0]);
        this.attachment.photos.push(files[0]);
      },

    },
    computed:{
      ...mapState ({
              modules:Modules => Store.state.Modules.modules,
              //freemodules:Modules => Store.state.Modules.freemodules
      })
    },
    components: {
      ConfirmSignup
    }
  };
</script>
<style>
  .v-dialog{
    box-shadow: none!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/WidgetComponents/CreatePackage.vue